import { z } from 'zod';

/** Where a driver stands on sharing their phone's location (gitaumoses4/chukua#60). Derived from the newest consent row, never stored. */
export const LOCATION_CONSENT_STATUSES = ['not_asked', 'foreground', 'background', 'withdrawn'] as const;
export type LocationConsentStatus = (typeof LOCATION_CONSENT_STATUSES)[number];

/** `POST /sync/consent`: what the driver chose on this phone. Background tracking needs foreground location first, as the OS requires. */
export const syncConsentRequestSchema = z
  .object({
    foreground: z.boolean(),
    background: z.boolean(),
  })
  .refine((choice) => choice.foreground || !choice.background, {
    message: 'Background location needs foreground location',
    path: ['background'],
  });
export type SyncConsentRequest = z.infer<typeof syncConsentRequestSchema>;

/** The current consent, from `GET /sync/consent`, the answer to a `POST`, and the office driver page. Null time and version while `not_asked`. */
export const locationConsentViewSchema = z.object({
  status: z.enum(LOCATION_CONSENT_STATUSES),
  recordedAt: z.iso.datetime().nullable(),
  appVersion: z.string().nullable(),
});
export type LocationConsentView = z.infer<typeof locationConsentViewSchema>;

/** Whether `GET /sync/trip` serves trips: `required` until the driver has consented to location. A missing field (an older server) means `granted`. */
export const SYNC_CONSENT_GATES = ['granted', 'required'] as const;
export const syncConsentGateSchema = z.enum(SYNC_CONSENT_GATES).default('granted');
export type SyncConsentGate = (typeof SYNC_CONSENT_GATES)[number];
